<template>
  <div>
      <slot/>      
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/desktop/template/Empty.vue